import { AbstractModel } from './abstract-model';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RuleValue extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  value: string;

  @autoserialize
  description: string;
}
